import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import { ImagebannerComponent } from './imagebanner.component';


@NgModule({
    declarations: [ImagebannerComponent],
    imports     : [BrowserModule, RouterModule],
    exports     : [ImagebannerComponent],
})

export class ImageBannerModule {}



// WEBPACK FOOTER //
// ./src/app/common/imagebanner/imagebanner.module.ts